import { Coord } from "../types/Interface";

export default function isCircumPointBetween(cCoord: Coord, cCircumPoint: Coord, aSide1: number, aSide2: number): boolean {
  let angle = Math.atan2(cCircumPoint.y - cCoord.y, cCircumPoint.x - cCoord.x);
  if (angle < 0) {
    angle += 2 * Math.PI;
  }

  let start = aSide1;
  let end = aSide2;

  if (start < 0) start += 2 * Math.PI;
  if (end < 0) end += 2 * Math.PI;
  if (start <= end) {
    return angle >= start && angle <= end;
  } else {
    return angle >= start || angle <= end;
  }
}